<template>
  <b-card no-body class="mt-3">
    <b-card-body>
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h4 class="mb-0">Termo de assinatura (aluguel)</h4>
        <small v-if="updatedAt" class="text-muted">
          Atualizado em: {{ updatedAt | formatDateTime }}
        </small>
      </div>

      <b-alert v-if="!canEdit" show variant="warning" class="mb-2">
        Apenas admins podem editar o termo.
      </b-alert>

      <b-form-textarea
        v-model="text"
        rows="8"
        max-rows="14"
        :disabled="loading || saving || !canEdit"
        placeholder="Digite o termo que será exibido para assinatura..."
      />

      <div class="d-flex justify-content-between align-items-center mt-2">
        <small class="text-muted">
          Esse termo será usado nos próximos aluguéis. Aluguéis antigos
          continuam com o texto salvo na assinatura.
        </small>

        <div class="d-flex gap-1">
          <b-button
            variant="outline-secondary"
            :disabled="loading || saving || !canEdit"
            @click="reset"
          >
            Desfazer
          </b-button>
          <b-button
            variant="primary"
            :disabled="loading || saving || !canEdit || !isDirty"
            @click="save"
          >
            Salvar termo
          </b-button>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { formatDateTime } from '@/helpers/date'
import services from '@/services'

export default {
  name: 'StoreRentTermsEditor',
  filters: { formatDateTime },
  props: {
    storeId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      loading: false,
      saving: false,
      text: '',
      originalText: '',
      updatedAt: null
    }
  },
  computed: {
    canEdit() {
      const userStores = this.$store.state.user?.currentUser?.userStores || []
      return userStores.some((us) => us.role === 'admin')
    },
    isDirty() {
      return (this.text || '').trim() !== (this.originalText || '').trim()
    }
  },
  watch: {
    storeId: {
      handler() {
        this.load()
      },
      immediate: true
    }
  },
  methods: {
    async load() {
      const id = Number(this.storeId)
      if (!id) return

      this.loading = true
      try {
        const res = await services.stores.fetchRentTerms(id)
        this.text = res?.rentTermText || ''
        this.originalText = this.text
        this.updatedAt = res?.updatedAt || null
      } catch (e) {
        this.$root.$toast?.error('Não foi possível carregar o termo da loja.')
      } finally {
        this.loading = false
      }
    },
    reset() {
      this.text = this.originalText
    },
    async save() {
      const id = Number(this.storeId)
      if (!id) return

      const rentTermText = (this.text || '').trim()
      if (!rentTermText) {
        this.$root.$toast?.error('O termo não pode ser vazio.')
        return
      }

      this.saving = true
      try {
        const res = await services.stores.updateRentTerms({
          storeId: id,
          rentTermText
        })
        this.text = res?.rentTermText || rentTermText
        this.originalText = this.text
        this.updatedAt = res?.updatedAt || null
        this.$root.$toast?.success('Termo atualizado com sucesso.')
      } catch (e) {
        this.$root.$toast?.error(
          e?.response?.data?.message ||
            'Não foi possível salvar o termo. Verifique suas permissões.'
        )
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
